"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.classes = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _bayes = _interopRequireWildcard(require("./bayes"));
var Khaiii = _interopRequireWildcard(require("khaiii"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t7 in e) "default" !== _t7 && {}.hasOwnProperty.call(e, _t7) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t7)) && (i.get || i.set) ? o(f, _t7, i) : f[_t7] = e[_t7]); return f; })(e, t); }
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _classPrivateFieldSet(s, a, r) { return s.set(_assertClassBrand(s, a), r), r; }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
var classes = exports.classes = ['ai_learning_classification', 'ai_learning_text'];
var KhaiiModule = {
  isInitialized: false,
  module: undefined,
  load: function load() {
    var _arguments = arguments,
      _this = this;
    return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee() {
      var resourceRoot;
      return _regenerator["default"].wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            resourceRoot = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : "".concat(Entry.Utils.getEntryjsPath(), "/extern/khaiii");
            if (!_this.isInitialized) {
              _context.next = 1;
              break;
            }
            return _context.abrupt("return");
          case 1:
            _context.next = 2;
            return Khaiii.initialize({
              resourceProvider: 'webfs',
              resourceRoot: resourceRoot
            });
          case 2:
            _this.module = _context.sent;
            _this.isInitialized = true;
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  }
};
var _type = /*#__PURE__*/new WeakMap();
var _url = /*#__PURE__*/new WeakMap();
var _labels = /*#__PURE__*/new WeakMap();
var _popup = /*#__PURE__*/new WeakMap();
var _result = /*#__PURE__*/new WeakMap();
var _loadModel = /*#__PURE__*/new WeakMap();
var TextNaiveBaye = /*#__PURE__*/function () {
  function TextNaiveBaye(_ref) {
    var url = _ref.url,
      labels = _ref.labels,
      modelId = _ref.modelId,
      loadModel = _ref.loadModel;
    (0, _classCallCheck2["default"])(this, TextNaiveBaye);
    _classPrivateFieldInitSpec(this, _type, 'text');
    _classPrivateFieldInitSpec(this, _url, '');
    _classPrivateFieldInitSpec(this, _labels, []);
    _classPrivateFieldInitSpec(this, _popup, null);
    _classPrivateFieldInitSpec(this, _result, []);
    _classPrivateFieldInitSpec(this, _loadModel, void 0);
    (0, _defineProperty2["default"])(this, "tokenizer", /*#__PURE__*/function () {
      var _ref2 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2(text) {
        var analized, filtered;
        return _regenerator["default"].wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (KhaiiModule.module) {
                _context2.next = 1;
                break;
              }
              throw new Error('module not loaded');
            case 1:
              if (text) {
                _context2.next = 2;
                break;
              }
              return _context2.abrupt("return", []);
            case 2:
              analized = KhaiiModule.module.analyze(text); // 형태소 분석 진행
              filtered = analized.map(function (wordInfo) {
                return wordInfo.morphs.filter(function (morph) {
                  var category = morph.tag.charAt(0);
                  return category === 'V' || category === 'N' || category === 'S';
                }).map(function (morph) {
                  return morph.lex;
                });
              }).flat();
              return _context2.abrupt("return", filtered);
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }());
    _classPrivateFieldSet(_url, this, url);
    _classPrivateFieldSet(_labels, this, labels);
    _classPrivateFieldSet(_loadModel, this, loadModel);
    this.classifier = new _bayes["default"]({
      tokenizer: this.tokenizer
    });
    this.load(url, modelId);
  }
  return (0, _createClass2["default"])(TextNaiveBaye, [{
    key: "labels",
    get: function get() {
      return _classPrivateFieldGet(_labels, this);
    }
  }, {
    key: "unbanBlocks",
    value: function unbanBlocks(blockMenu) {
      blockMenu.unbanClass("ai_learning_classification");
      blockMenu.unbanClass("ai_learning_text");
    }
  }, {
    key: "isAvailable",
    value: function isAvailable() {
      if (!this.isLoaded) {
        throw new Error('ai learning text model load error');
      }
      return true;
    }
  }, {
    key: "getResult",
    value: function getResult(index) {
      var _classPrivateFieldGet2,
        _classPrivateFieldGet3,
        _this2 = this;
      var result = (_classPrivateFieldGet2 = _classPrivateFieldGet(_result, this)) !== null && _classPrivateFieldGet2 !== void 0 && _classPrivateFieldGet2.length ? _classPrivateFieldGet(_result, this) : ((_classPrivateFieldGet3 = _classPrivateFieldGet(_popup, this)) === null || _classPrivateFieldGet3 === void 0 ? void 0 : _classPrivateFieldGet3.result) || [];
      var defaultResult = {
        probability: 0,
        className: ''
      };
      if (index !== undefined && index > -1) {
        return result.find(function (_ref3) {
          var className = _ref3.className;
          return className === _classPrivateFieldGet(_labels, _this2)[index];
        }) || defaultResult;
      }
      return result[0] || defaultResult;
    }
  }, {
    key: "openInputPopup",
    value: function openInputPopup() {
      var _this3 = this;
      var isAvailable = this.isAvailable();
      if (!isAvailable) {
        return;
      }
      _classPrivateFieldSet(_result, this, []);
      Entry.dispatchEvent('openMLInputPopup', {
        type: 'text',
        predict: function () {
          var _predict = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee3(text) {
            var _t, _t2, _t3;
            return _regenerator["default"].wrap(function (_context3) {
              while (1) switch (_context3.prev = _context3.next) {
                case 0:
                  _t = _classPrivateFieldSet;
                  _t2 = _result;
                  _t3 = _this3;
                  _context3.next = 1;
                  return _this3.predict(text);
                case 1:
                  _t(_t2, _t3, _context3.sent);
                case 2:
                case "end":
                  return _context3.stop();
              }
            }, _callee3);
          }));
          function predict(_x2) {
            return _predict.apply(this, arguments);
          }
          return predict;
        }(),
        url: _classPrivateFieldGet(_url, this),
        labels: _classPrivateFieldGet(_labels, this),
        setResult: function setResult(result) {
          _classPrivateFieldSet(_result, _this3, result);
        }
      });
    }
  }, {
    key: "predict",
    value: function () {
      var _predict2 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee4(textData) {
        var _t4, _t5, _t6;
        return _regenerator["default"].wrap(function (_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 1;
              return KhaiiModule.load();
            case 1:
              _t4 = _classPrivateFieldSet;
              _t5 = _result;
              _t6 = this;
              _context4.next = 2;
              return this.classifier.categorize(textData);
            case 2:
              _t4(_t5, _t6, _context4.sent);
              return _context4.abrupt("return", _classPrivateFieldGet(_result, this));
            case 3:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function predict(_x3) {
        return _predict2.apply(this, arguments);
      }
      return predict;
    }()
  }, {
    key: "load",
    value: function () {
      var _load = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee5(url, modelId) {
        var data;
        return _regenerator["default"].wrap(function (_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 1;
              return _classPrivateFieldGet(_loadModel, this).call(this, {
                url: url,
                modelId: modelId
              });
            case 1:
              data = _context5.sent;
              if (data) {
                _context5.next = 2;
                break;
              }
              return _context5.abrupt("return");
            case 2:
              this.classifier = (0, _bayes.fromJson)(JSON.stringify(data));
              this.classifier.tokenizer = this.tokenizer;
              this.isLoaded = true;
            case 3:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function load(_x4, _x5) {
        return _load.apply(this, arguments);
      }
      return load;
    }()
  }]);
}();
var _default = exports["default"] = TextNaiveBaye;